<template>
    <div class="featureParent" 
        :class="[classControl]" 
        :style="{'transform':(feashow ? 'scale(1,1)': 'scale(0,0)'),'left':(navStable?'210px':'50px')}" 
        @mouseenter="myshow" 
        @mouseleave="myhide">
        <div class="feature">
            <!-- <div class="triangle-top" :style="{'left':($i18n.locale === 'zh' ? '140px' : '270px')}"></div> -->
            <div class="shuticon" @click="shutList"><i class="el-icon-close"></i></div>
            <div class="feacon">
                <header>
                    <el-input ref="searchInput" v-model="searchVal" :placeholder='$t("featurelist.placeholder")' suffix-icon='iconfont icon-search'></el-input>
                </header>
                <main>
                    <waterfall :col="4" :data="searchModuleList" :width="200" :gutterWidth="10">
                        <div class="waterf" v-for="(list,index) in searchModuleList" :key="index">
                            <template>
                                <h1>
                                    <i class="iconfont icon-help hidden"></i>
                                    <span class="featitle" v-if="$i18n.locale === 'zh'">{{list.title}}</span>
                                    <span class="featitle" v-if="$i18n.locale === 'en'">{{list.enTitle}}</span>
                                </h1>
                                <ul class="childlist">
                                    <li v-for="item in list.children" :key="item.path" @click="openStatic(item)" @mouseenter="listhover1($event,item)" @mouseleave="listhover2($event,item)">
                                        <span class="flex">
                                            <i v-show="item.iconName" :class="['iconfont',item.iconName,'ics']" class="ics iconfont"></i>
                                            <span class="mdName" v-if="$i18n.locale === 'zh'">{{item.moduleName}}</span>
                                            <span class="mdName" v-if="$i18n.locale === 'en'" :title="item.moduleEnName">{{item.moduleEnName}}</span>
                                        </span>
                                        <i @click.stop="uncollect(item)" v-show="item.collect" class="iconfont icon-collection hover" @mouseenter="listhover3" @mouseleave="listhover4">
                                            <div class="tooltip">
                                                <span v-if="$i18n.locale === 'zh'">取消</span>
                                                <span v-if="$i18n.locale === 'en'">Del</span>
                                                <div class="arrow"></div>
                                            </div>
                                        </i>
                                        <i @click.stop="addcollect(item)" v-show="!item.collect" class="iconfont icon-uncollection hover" @mouseenter="listhover3" @mouseleave="listhover4">
                                            <div class="tooltip">
                                                <span v-if="$i18n.locale === 'zh'">添加</span>
                                                <span v-if="$i18n.locale === 'en'">Add</span>
                                                <div class="arrow"></div>
                                            </div>
                                        </i>
                                    </li>
                                </ul>
                            </template>
                        </div>
                    </waterfall>
                </main>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import across from "@/config/components/across.js"
import { Mixins } from '@/config/mixins/mixins'
import { $http } from '@/config/api/axios'
import { get_session_cache } from "@/config/cache/cache.js"
export default {
    name:'Featurelist',
    mixins:[Mixins],
    props:{
        isShow:false,
    },
    computed:{
        feashow:function(){
            return this.isShow || this.selfhov
        },
        ...mapGetters('Home', [
            'navStable',
            'allCollect',
            'collect'
        ]),
    },
    watch:{
        isShow(n,o){
            if(n){
                this.shutflag = false;
            }
        },
        searchVal(val){
            // val = val.replace(/\s+/g, "")
            val = val.replace(/^\s*(.*?)\s*$/g, "$1")
            this.throttle(val)
        }
    },
    data(){
        return{
            throttle:'',
            selfhov:false,
            shutflag:false,
            searchVal:'',
            hoverObj:{
                color:'inherit',
            },
            hoverIconflag:false,
            classControl:'',
            searchModuleList:[],
            cacheAll:[],
        }
    },
    methods:{
        ...mapMutations('Home',[
            'SET_ACTIVE_NAV',
            'SET_ALL_COLLECT'
        ]),
        ...mapActions('Home', [
            'get_Allroutes'
        ]),
        myshow(){
            if(!this.shutflag){
                this.selfhov = true;
            }
        },
        myhide(){
            this.selfhov = false;
            // this.$refs.searchInput.blur()
        },
        shutList(){
            this.shutflag = true;
            this.selfhov = false;
        },
        listhover1(ev,item){
            if(item.collect){
                let li = ev.target.children[1]
                li.style.display = 'inline';
            }else{
                let li = ev.target.children[2]
                li.style.display = 'inline';
            }
        },
        listhover2(ev,item){
            if(item.collect){
                let li = ev.target.children[1]
                li.style.display = 'none';
            }else{
                let li = ev.target.children[2]
                li.style.display = 'none';
            }
        },
        listhover3(e){
            let tooltip = e.target.firstElementChild;
            tooltip.style.display = 'block';
        },
        listhover4(e){
            let tooltip = e.target.firstElementChild;
            tooltip.style.display = 'none';
        },
        async addcollect(obj){
            $http("post", "/collectModule/isCollectModule",{id:obj.id,isCollect:'1'})
            .then((res)=>{
                if(res.status === 'SUCCESS'){
                    obj.collect = true
                    this.collect.push(obj)
                    if(this.collect.length>0){
                        this.collect.forEach((item,index) => {
                            if(this.$route.path === `/${this.$root.$lang}/${item.path}`){
                                this.SET_ACTIVE_NAV(index)
                            }
                        })
                    }
                    this.setCatch(obj,true)
                    this.msgsuccess(this.$t("featurelist.tip1"))
                }else{
                    this.msgerror(this.$t("featurelist.tip2"))
                }
            })
        },
        uncollect(obj){
            $http("post", "/collectModule/isCollectModule",{id:obj.id,isCollect:'0'})
            .then((res)=>{
                if(res.status === 'SUCCESS'){
                    let uncollIndex = -2;
                    obj.collect = false
                    if(this.collect.length>0){
                        let spliceIndex;
                        for(let i=0; i<this.collect.length; i++){
                            if(this.collect[i].path === obj.path){
                                spliceIndex = i;
                                break
                            }
                        }
                        this.collect.splice(spliceIndex,1)
                        this.collect.forEach((item,index) => {
                            if(this.$route.path === `/${item.path}`){
                                uncollIndex = index
                            }
                        })
                        this.SET_ACTIVE_NAV(uncollIndex)
                        this.setCatch(obj,false)
                    }
                    this.msgsuccess(this.$t("featurelist.tip3"))
                }else{
                    this.msgerror(this.$t("featurelist.tip4"))
                }
            })
        },
        setCatch(obj,boolean){
            this.cacheAll.forEach(modules=>{
                if(modules.moduleCode === obj.parentCode){
                    modules.children.forEach(item=>{
                        if(item.id === obj.id){
                            item.collect = boolean
                        }
                    })
                }
            })
            this.SET_ALL_COLLECT(this.cacheAll);
        },
        openStatic(obj){
            let openIndex = -2;
            if(obj.collect){
                for(let i=0; i<this.collect.length; i++){
                    if(this.collect[i].path === obj.path){ // 收藏列表中是否有该模块
                        openIndex = i;
                        break
                    }
                }
            }
            this.SET_ACTIVE_NAV(openIndex)
            across.$emit('addCollect',obj,'isOpen')
        },
        filter(val){
            if(val.length>0){
                this.searchModuleList = [];
                this.allCollect.forEach((modules)=>{
                    let flag = false;
                    let modulesObj = {}
                    let childArr = []
                    modules.children.forEach((child,index)=>{
                        if(this.$root.$lang === 'zh-CN'){
                            if(child.moduleName.includes(val)){
                                childArr.push(JSON.parse(JSON.stringify(modules.children[index])))
                                // childArr.push(modules.children[index])
                                flag = true;
                            }
                        }else{
                            if(child.moduleEnName.toLowerCase().includes(val.toLowerCase())){
                                childArr.push(JSON.parse(JSON.stringify(modules.children[index])))
                                // childArr.push(modules.children[index])
                                flag = true;
                            }
                        }
                    })
                    if(flag){
                        modulesObj = JSON.parse(JSON.stringify(modules))
                        modulesObj.children = childArr;
                        this.searchModuleList.push(modulesObj)
                    }
                })
            }else{
                this.searchModuleList = JSON.parse(JSON.stringify(this.allCollect))
                // this.searchModuleList = this.allCollect
            }
        },
    },
    created(){
        const token = get_session_cache("Access-Token");
        if(!!token){
            this.pageLoading(true)
            this.get_Allroutes().
            then(res => {
                this.pageLoading(false)
                this.cacheAll = JSON.parse(JSON.stringify(this.allCollect));
                this.searchModuleList.push(...res)
                if(this.$i18n.locale == 'zh'){
                    if(res.length === 2 || res.length === 1){
                        this.classControl = 'wid450'
                    }
                    if(res.length === 3){
                        this.classControl = 'wid660'
                    }
                    if(res.length >= 4){
                        this.classControl = 'wid870'
                    }
                }
                if(this.$i18n.locale == 'en'){
                    if(res.length === 2 || res.length === 1){
                        this.classControl = 'en-wid450'
                    }
                    if(res.length === 3){
                        this.classControl = 'en-wid660'
                    }
                    if(res.length >= 4){
                        this.classControl = 'en-wid870'
                    }
                }
            })
            this.throttle = this.debounce(this.filter)
        }
    },
}
</script>

<style lang="less">
.featureParent{
    position: absolute;
    top: 45px;
    left: 50px;
    height: calc(100% - 55px);
    z-index: 8100;
    transition: all .4s ease-in-out;
    
}
.wid450{
    width: 450px;
    transform-origin: 0% 1%;
}
.wid660{
    width: 660px;
    transform-origin: 0% 1%;
}
.wid870{
    width: 870px;
    transform-origin: 0% 1%;
}
.en-wid450{
    width: 450px;
    transform-origin:0% 1%;
}
.en-wid660{
    width: 660px;
    transform-origin: 0% 1%;
}
.en-wid870{
    width: 870px;
    transform-origin: 0% 1%;
}
.feature{
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10;
    width: 100%;
    height: 100%;
    padding-top: 10px;
    user-select: none;
    .triangle-top{
        position: absolute;
        top: 1px;
        left: 140px;
        width: 0;
        height: 0;
        border-right: 6px solid transparent;
        border-bottom: 9px solid #fff;
        border-left: 6px solid transparent;
    }
    .shuticon{
        position: absolute;
        right: 20px;
        top: 20px;
        font-size: 20px;
        cursor: pointer;
    }
    .feacon{
        width: 100%;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0px 0px 5px rgba(68, 48, 96, 0.2);
        background: #fff;
        padding: 20px;
        padding-bottom: 0;
        padding-right: 0;
        header{
            width: 100%;
            .el-input{
                width: 55%;
            }
        }
        main{
            width: 100%;
            height: calc(100% - 48px);
            padding-top: 15px;
            color:#404042;
            overflow-y: auto;
            .vue-waterfall{
                overflow-y: visible;
            }
            .waterf{
                h1{
                    height: 26px;
                }
                .featitle{
                    font-weight: bold;
                    margin-left: 10px;
                }
                .hidden{
                    visibility: hidden;
                }
                .ics{
                    display: initial;
                    margin-right: 6px;
                    cursor: initial;
                }
            }
            .childlist{
                margin-bottom: 25px;
                margin-left: 25px;
                li{
                    height: 24px;
                    display: flex;
                    justify-content: space-between;
                    &:hover{
                        color: #4980d7;
                    }
                    i{
                        cursor: pointer;
                        display: none;
                    }
                    .hover{
                        position: relative;
                        .tooltip{
                            position: absolute;
                            left: -11px;
                            top: -30px;
                            background: #303133;
                            color: #fff;
                            min-width: 40px;
                            padding: 5px;
                            font-size: 12px;
                            border-radius: 4px;
                            text-align: center;
                            cursor: initial;
                            display: none;
                            .arrow{
                                position: absolute;
                                display: block;
                                width: 0;
                                height: 0;
                                border-color: transparent;
                                border-style:  solid;
                                border-width:6px;
                                bottom: -6px;
                                border-top-color:#303133;
                                border-bottom-width: 0;
                                left: 13px;
                            }
                            &:hover{
                                background: red;
                                display: none !important;
                            }
                        }
                    }
                    .mdName{
                        display: inline-block;
                        width: 135px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .flex{
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
        main::-webkit-scrollbar{
            width: 4px;
        }
        main::-webkit-scrollbar-thumb{
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(38, 38, 38, 0.2);
            background: rgba(38, 38, 38, 0.2);
        }
        main::-webkit-scrollbar-track{
            box-shadow: inset 0 0 5px rgba(38, 38, 38, 0.1);
            border-radius: 0;
            background: rgba(38, 38, 38, 0.1);
        }
    }
}
.en-US{
    .feature .feacon main .childlist li>i{
        line-height: 2;
    }
}
</style>